module.exports = __webpack_public_path__ + "static/img/SD-WAN.fe175f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awards/SD-WAN.png
// module id = TbEQ
// module chunks = 0